module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_6005.35b49337.png";